<template>
	<div id="body">
		<div class="title">
			<i class="bi bi-ui-checks-grid"> </i> 会员中心
		</div>
		
		<div class="backgourp":style="{backgroundImage:`url(${imgSrc})`}">
			<div class="image">
				<img src="../assets/image.jpg" id="userimg">
			</div>
			<div>
				<div id="username">{{this.$store.state.username}}</div>
			</div>
		</div>
		
		<div id="top-item" class="shadow p-3 mb-5 bg-white rounded">
			<div class="list-top-item" style="background-image:-webkit-linear-gradient(top,#FFFFFF,#fab6b6);">
				<i class="bi bi-ui-checks top-item-i" style="color: #dd6161;"></i>
				<div style="font-size: 0.925rem;">历史查询</div>
			</div>
			
			<div class="list-top-item top-item-i" style="background-image:-webkit-linear-gradient(top,#FFFFFF,#fcbd71);">
				<i class="bi bi-award" style="color: #f29100;"></i>
				<div>钱包</div>
			</div>
			<div class="list-top-item top-item-i" style="background-image:-webkit-linear-gradient(top,#FFFFFF,#71d5a1);">
				<i class="bi bi-bank" style="color: #18b566;"></i>
				<div style="font-size: 0.925rem;">营业执照</div>
			</div>
			<div class="list-top-item top-item-i" id="request" style="background-image:-webkit-linear-gradient(top,#FFFFFF,#c8c9cc);">
				<i class="bi bi-basket-fill" style="color: #82848a;"></i>
				<div>注销</div>
			</div>
		</div>
		
		<div id="item">
			<ul class="list-group">
			  <li class="list-group-item d-flex justify-content-between align-items-center">
			    <i class="bi bi-distribute-vertical"> 意见反馈</i>
			    <span class="badge badge-primary badge-pill">14</span>
			  </li>
			  <li class="list-group-item d-flex justify-content-between align-items-center">
			    <i class="bi bi-broadcast"> 常见问题</i>
			    <span class="badge badge-primary badge-pill">2</span>
			  </li>
			  <li class="list-group-item d-flex justify-content-between align-items-center">
			    <i class="bi bi-ui-radios"> 版本升级</i>
			    <span class="badge badge-primary badge-pill">1</span>
			  </li>
			</ul>
		</div>
		
		
		<div id="item-bottom">
			<ul class="list-group" id="group-border">
			  <li class="list-group-item d-flex justify-content-between align-items-center">
				<i class="bi bi-toggles"> 个人信息</i>
			  </li>
			  <li class="list-group-item d-flex justify-content-between align-items-center">
			  	<i class="bi bi-toggles" @click="signout"> 退出登录</i>
			  </li>
			</ul>
		</div>
	</div>
</template>

<script>
	import {mapMutations} from 'vuex'
	export default {
		data(){
			return{
				imgSrc:require('../assets/back.jpg')
			}
		},
		methods:{
			...mapMutations(['changeLogin']), 
			signout(){
				this.changeLogin({ Authorization: "" });
				this.$router.push('/login')
			}
		}
	}
</script>

<style scoped="scoped">
	#body{
		background-color: #f5f5f5;
		margin-top: 30px;
	}
		
	.backgourp{
		width: 100%;
		height: 16.375rem;
		text-align: center;
		background-size: 100% 100%;
		border-bottom-right-radius: 20% ;
		border-bottom-left-radius: 20% ;
	}
	.image{
		padding-top: 13%;
	}
	#userimg{
		border-radius: 50%;
		width: 5rem;
		height: 5rem;
	}
	#username{
		margin-top: 2%;
		color: #FFFFFF;
		font-size: 1.2375rem;
	}
	
	
	#top-item{
		background-color: aliceblue;
		width: 85%;
		height: 5.05rem;
		margin:0 auto;
		margin-top: -3.125rem;
		border: 0.0625rem solid #FFFFFF;
		margin-bottom: 1.25rem;
		display: flex;/*重要*/ /*横向排列*/
		align-items: center; /*重要*/ /*子类居中*/
	}
	.list-top-item{
		border-radius: 10%;
		display: inline-block;
		width: 23.5%;
		line-height: 30px;
		text-align: center;
		margin: 0 auto; /*重要*/ /*子类居中*/
	}
	.top-item-i{
		size: 3.125rem;
	}
	
	#item{
		width: 98%;
		margin: 0 auto;
		height: 18.75rem;
		margin-top: -2.25rem;
	}
	
	#item-bottom{
		width: 98%;
		margin: 0 auto;
		margin-top: -8.5rem;
	}
	
	.align-items-center{
		border-radius: 5%;
	}
	
	.bi{
		font-style:normal;
	}
</style>
